import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileInvoiceDollar } from '@fortawesome/free-solid-svg-icons';

interface EmptyStateProps {
  message: string;
}

/**
 * Component to display when no data is available
 */
const EmptyState: React.FC<EmptyStateProps> = ({ message }) => (
  <div className="text-center py-5">
    <div className="mb-3">
      <FontAwesomeIcon icon={faFileInvoiceDollar} className="text-muted" style={{ fontSize: '3rem' }} />
    </div>
    <h5>{message}</h5>
  </div>
);

export default React.memo(EmptyState);
